import { ProductCardProps, ProductInfo } from '@core-ui/product-card/types';
import buildProductLink from '@core-ui/product-card/src/collaborators/build-product-link/index';
import { getLocationSearch, getHashParameter } from '@core-ui/url-helper';

type ProductLinkProps = {
  product: ProductInfo
} & Pick<
      ProductCardProps,
      'cid' | 'pcid' | 'productGridSource' | 'cardIndex' | 'totalCount' | 'pageIndex'
      >;

export const productLinkAdapter = ({
  product: { productID: pid, additionalQueryParams, vid, outOfStock },
  cid,
  pcid,
  productGridSource,
  cardIndex,
  totalCount,
  pageIndex
}: ProductLinkProps) => {
  if (outOfStock) {
    return null;
  }

  return buildProductLink({
    pid,
    additionalQueryParams,
    cid,
    pcid,
    vid,
    grid: {
      productGridSource,
      cardIndex,
      totalCount,
      pageIndex,
    },
    nav: new URLSearchParams(getLocationSearch()).get('nav'),
    storeId: getHashParameter('storeId'),
  });
};
